export const PatientLabReadingTypes = Object.freeze({
  A1c: { id: 1, label: 'HbA1c' },
  Weight: { id: 2, label: 'Weight (lbs)' },
  LDL: { id: 3, label: 'LDL (mg/dL)' },
  Height: { id: 4, label: 'Height (in)' },
});

export const ALL_LAB_READING_TYPES = Object.freeze({
  id: -1,
  label: 'All Vital and Result Types',
});

export const LabReadingTypes = [
  ALL_LAB_READING_TYPES,
  ...Object.values(PatientLabReadingTypes).map((type) => ({
    id: type.id,
    label: type.label.split('(')[0],
  })),
];

export const LabReadingSort = Object.freeze({
  NEWEST_FIRST: 'Newest first',
  OLDEST_FIRST: 'Oldest first',
});

export const VitalsLabsTypes = Object.freeze({
  HbA1c: { value: 1, label: 'HbA1c', creatable: true, category: 'HbA1c', unit: '', options: null },
  Weight: {
    value: 2,
    label: 'Weight',
    creatable: false,
    category: 'Weight',
    unit: 'Lbs',
    options: null,
  },
  LDL: {
    value: 3,
    label: 'LDL cholesterol (calculated)',
    creatable: true,
    category: 'Lipids',
    unit: 'mg/dl',
    options: null,
  },
  Height: {
    value: 4,
    label: 'Height',
    creatable: false,
    category: 'Height',
    unit: 'Inches',
    options: null,
  },
  Glucose: {
    value: 5,
    label: 'Glucose',
    creatable: true,
    category: 'CMP',
    unit: 'mg/dl',
    options: null,
  },
  BUN: { value: 6, label: 'BUN', creatable: false, category: 'CMP', unit: 'mg/dl', options: null },
  Creatinine: {
    value: 7,
    label: 'Creatinine',
    creatable: true,
    category: 'eGFR',
    unit: 'mg/dl',
    options: null,
  },
  GFR: {
    value: 8,
    label: 'GFR',
    creatable: false,
    category: 'CMP',
    unit: 'mL/min/1.73',
    options: null,
  },
  EGFRNonAfricanAmerican: {
    value: 9,
    label: 'eGFR, non african american',
    creatable: true,
    category: 'CMP',
    unit: 'mL/min/1.73',
    options: null,
  },
  EGFRAfricanAmerican: {
    value: 10,
    label: 'eGFR, african american',
    creatable: true,
    category: 'CMP',
    unit: 'mL/min/1.73',
    options: null,
  },
  Sodium: {
    value: 11,
    label: 'Sodium',
    creatable: true,
    category: 'CMP',
    unit: 'mmol/l',
    options: null,
  },
  Potassium: {
    value: 12,
    label: 'Potassium',
    creatable: true,
    category: 'CMP',
    unit: 'mmol/l',
    options: null,
  },
  Chloride: {
    value: 13,
    label: 'Chloride',
    creatable: true,
    category: 'CMP',
    unit: 'mmol/l',
    options: null,
  },
  CarbonDioxide: {
    value: 14,
    label: 'Carbon Dioxide',
    creatable: true,
    category: 'CMP',
    unit: 'mmol/l',
    options: null,
  },
  Calcium: {
    value: 15,
    label: 'Calcium',
    creatable: true,
    category: 'CMP',
    unit: 'mg/dl',
    options: null,
  },
  Protein: {
    value: 16,
    label: 'Total Protein',
    creatable: true,
    category: 'CMP',
    unit: 'g/dl',
    options: null,
  },
  Albumin: {
    value: 17,
    label: 'Albumin',
    creatable: true,
    category: 'CMP',
    unit: 'g/dl',
    options: null,
  },
  Globulin: {
    value: 18,
    label: 'Globulin (calculated)',
    creatable: true,
    category: 'CMP',
    unit: 'g/dl',
    options: null,
  },
  BillrubinTotal: {
    value: 19,
    label: 'Total Bilirubin',
    creatable: true,
    category: 'CMP',
    unit: 'g/dl',
    options: null,
  },
  AlkalinePhosphatase: {
    value: 20,
    label: 'Alkaline Phosphatase',
    creatable: true,
    category: 'CMP',
    unit: 'IU/L',
    options: null,
  },
  ALT: { value: 21, label: 'ALT', creatable: true, category: 'CMP', unit: 'IU/L', options: null },
  AST: { value: 22, label: 'AST', creatable: true, category: 'CMP', unit: 'IU/L', options: null },
  CholesterolTotal: {
    value: 23,
    label: 'Cholesterol, Total',
    creatable: true,
    category: 'Lipids',
    unit: 'mg/dl',
    options: null,
  },
  HDLCholesterol: {
    value: 24,
    label: 'HDL cholesterol (calculated)',
    creatable: true,
    category: 'Lipids',
    unit: 'mg/dl',
    options: null,
  },
  Triglycerides: {
    value: 25,
    label: 'Triglycerides',
    creatable: true,
    category: 'Lipids',
    unit: 'mg/dl',
    options: null,
  },
  NonHDLCholesterol: {
    value: 26,
    label: 'Non-HDL Cholesterol (calculated)',
    creatable: true,
    category: 'Lipids',
    unit: 'mg/dl',
    options: null,
  },
  CHOLHDLCRatio: {
    value: 27,
    label: 'CHOL/HDLC ratio',
    creatable: false,
    category: 'Lipids',
    unit: 'mg/dl',
    options: null,
  },
  VLDL: {
    value: 28,
    label: 'VLDL',
    creatable: false,
    category: 'Lipids',
    unit: 'mg/dl',
    options: null,
  },
  WBC: { value: 29, label: 'WBC', creatable: true, category: 'CBC', unit: 'K/mm3', options: null },
  RBC: { value: 30, label: 'RBC', creatable: true, category: 'CBC', unit: 'M/mm3', options: null },
  Hgb: { value: 31, label: 'Hgb', creatable: false, category: 'CBC', unit: 'g/dl', options: null },
  Hct: { value: 32, label: 'Hct', creatable: false, category: 'CBC', unit: '%', options: null },
  MCH: { value: 33, label: 'MCH', creatable: true, category: 'CBC', unit: 'pg', options: null },
  MCHC: { value: 34, label: 'MCHC', creatable: true, category: 'CBC', unit: 'g/dl', options: null },
  MCV: { value: 35, label: 'MCV', creatable: true, category: 'CBC', unit: 'fl', options: null },
  Platelets: {
    value: 36,
    label: 'Platelet Count',
    creatable: true,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  RDW: { value: 37, label: 'RDW', creatable: true, category: 'CBC', unit: '%', options: null },
  NeutrophilPercent: {
    value: 38,
    label: 'Neutrophil',
    creatable: false,
    category: 'CBC',
    unit: '%',
    options: null,
  },
  Neutrophils: {
    value: 39,
    label: 'Neutrophils',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  NeutrophilsAbsolute: {
    value: 40,
    label: 'Neutrophils (absolute)',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  Lymphs: {
    value: 41,
    label: 'Lymphs',
    creatable: false,
    category: 'CBC',
    unit: '%',
    options: null,
  },
  LymphsAbsolute: {
    value: 42,
    label: 'Lymphs (absolute)',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  MonocytePercent: {
    value: 43,
    label: 'Monocyte',
    creatable: false,
    category: 'CBC',
    unit: '%',
    options: null,
  },
  Monocytes: {
    value: 44,
    label: 'Monocytes',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  MonocytesAbsolute: {
    value: 45,
    label: 'Monocytes (absolute)',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  EosinophilPercent: {
    value: 46,
    label: 'Eosinophil',
    creatable: false,
    category: 'CBC',
    unit: '%',
    options: null,
  },
  Eosinophils: {
    value: 47,
    label: 'Eosinophils',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  EosinophilsAbsolute: {
    value: 48,
    label: 'Eosinophils (absolute)',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  BasophilPercent: {
    value: 49,
    label: 'Basophil',
    creatable: false,
    category: 'CBC',
    unit: '%',
    options: null,
  },
  Basophils: {
    value: 50,
    label: 'Basophils',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  BasophilsAbsolute: {
    value: 51,
    label: 'Basophils (absolute)',
    creatable: false,
    category: 'CBC',
    unit: 'K/mm3',
    options: null,
  },
  uACR: {
    value: 52,
    label: 'uACR',
    creatable: true,
    category: 'uACR',
    unit: 'mg/g',
    options: null,
  },
  eGFR: {
    value: 53,
    label: 'eGFR',
    creatable: true,
    category: 'eGFR',
    unit: 'mL/min/1.73',
    options: null,
  },
  CystatinC: {
    value: 54,
    label: 'Cystatin C',
    creatable: true,
    category: 'eGFR',
    unit: 'mg/L',
    options: null,
  },
  AlbuminGlobulinRatio: {
    value: 55,
    label: 'Albumin/Globulin Ratio (calculated)',
    creatable: true,
    category: 'CMP',
    unit: '',
    options: null,
  },
  BUNCreatinineRatio: {
    value: 56,
    label: 'BUN/Creatinine Ratio (calculated)',
    creatable: true,
    category: 'CMP',
    unit: '',
    options: null,
  },
  CreatinineWithGFREstimated: {
    value: 57,
    label: 'Creatinine with GFR (estimated)',
    creatable: true,
    category: 'CMP',
    unit: 'mg/dL',
    options: null,
  },
  UreaNitrogen: {
    value: 58,
    label: 'Urea Nitrogen',
    creatable: true,
    category: 'CMP',
    unit: 'mg/dL',
    options: null,
  },
  Hemoglobin: {
    value: 59,
    label: 'Hemoglobin',
    creatable: true,
    category: 'CBC',
    unit: 'g/dL',
    options: null,
  },
  Hematocrit: {
    value: 60,
    label: 'Hematocrit',
    creatable: true,
    category: 'CBC',
    unit: '%',
    options: null,
  },
  TSH: {
    value: 61,
    label: 'TSH',
    creatable: true,
    category: 'Thyroid',
    unit: 'µIU/mL',
    options: null,
  },
  FreeT4: {
    value: 62,
    label: 'Free T4',
    creatable: true,
    category: 'Thyroid',
    unit: 'ng/dL',
    options: null,
  },
  ApoEGenotype: {
    value: 63,
    label: 'ApoE Genotype',
    creatable: true,
    category: 'ApoE Genotype',
    unit: '',
    options: null,
  },
  VitD: {
    value: 64,
    label: 'Vitamin D',
    creatable: true,
    category: 'Vitamin D',
    unit: 'ng/mL',
    options: null,
  },
  VitB12: {
    value: 65,
    label: 'Vitamin B12',
    creatable: true,
    category: 'Vitamin B12',
    unit: 'pg/mL',
    options: null,
  },
  Folate: {
    value: 66,
    label: 'Folate',
    creatable: true,
    category: 'Folate',
    unit: 'ng/mL',
    options: null,
  },
  Thiamine: {
    value: 67,
    label: 'Thiamine',
    creatable: true,
    category: 'Thiamine',
    unit: 'nmol/L or µg/dL',
    options: null,
  },
  LymeTier1: {
    value: 68,
    label: 'Lyme - Tier 1: Total Ig Immunoassay',
    creatable: true,
    category: 'Lyme',
    unit: '',
    options: [
      { value: 0.0, label: 'Negative' },
      { value: 1.0, label: 'Positive/Equivocal' },
    ],
  },
  LymeTier2a: {
    value: 69,
    label: 'Lyme - Tier 2a: IgM Immunoblot',
    creatable: true,
    category: 'Lyme',
    unit: '',
    options: [
      { value: 0.0, label: 'Negative' },
      { value: 1.0, label: 'Positive/Equivocal' },
    ],
  },
  LymeTier2b: {
    value: 70,
    label: 'Lyme - Tier 2b: IgG Immunoblot',
    creatable: true,
    category: 'Lyme',
    unit: '',
    options: [
      { value: 0.0, label: 'Negative' },
      { value: 1.0, label: 'Positive/Equivocal' },
    ],
  },
});

export const LabReadingStatus = Object.freeze({
  Active: 1,
  Inactive: 2,
});

export const VITAL_MEASUREMENT_TYPE_IDS = [
  VitalsLabsTypes.Weight.value,
  VitalsLabsTypes.Height.value,
];

const HEDIS_EXCLUDED_TYPE_IDS = [
  VitalsLabsTypes.Weight.value,
  VitalsLabsTypes.Height.value,
  VitalsLabsTypes.uACR.value,
  VitalsLabsTypes.eGFR.value,
  VitalsLabsTypes.CystatinC.value,
  VitalsLabsTypes.AlbuminGlobulinRatio.value,
  VitalsLabsTypes.BUNCreatinineRatio.value,
  VitalsLabsTypes.CreatinineWithGFREstimated.value,
  VitalsLabsTypes.UreaNitrogen.value,
  VitalsLabsTypes.Hemoglobin.value,
  VitalsLabsTypes.Hematocrit.value,
];

export const LabReadingFilter = Object.values(VitalsLabsTypes)
  .filter((type) => !VITAL_MEASUREMENT_TYPE_IDS.includes(type.value))
  .map((type) => ({
    value: [type.value],
    label: type.label,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const HedisExcludedLabReadingFilter = Object.values(VitalsLabsTypes)
  .filter((type) => !HEDIS_EXCLUDED_TYPE_IDS.includes(type.value))
  .map((type) => ({
    value: [type.value],
    label: type.label,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const LabResultsTypeIds = Object.values(VitalsLabsTypes)
  .filter((labType) => !VITAL_MEASUREMENT_TYPE_IDS.includes(labType.value))
  .map((labType) => labType.value);

export const HedisExcludedLabResultTypeIds = Object.values(VitalsLabsTypes)
  .filter((labType) => !HEDIS_EXCLUDED_TYPE_IDS.includes(labType.value))
  .map((labType) => labType.value);
